import React, { useState, useMemo, useEffect } from "react";
import * as editorHTML from "editorjs-html";

import {
  titleParser,
  subtitleParser,
  listParser,
  bodyParser,
  imageParser,
  entityImageParser,
} from "../../screens/presentations/partials/slide/view/blockParsers";

export default function PostBodyParser(props) {
  const editorData = props.editorData;
  const isLive = !props.preview;
  const editorParser = useMemo(() =>
    editorHTML({
      title: (block) => titleParser(block),
      subtitle: (block) => subtitleParser(block),
      list: (block) => listParser(block),
      body: (block) => bodyParser(block, editorData),
      summary: (block) => bodyParser(block, editorData),
      gallery: (block) => {},
      image: (block) =>
        entityImageParser(
          block,
          editorData,
          isLive,
          props.entityType,
          props.postId,
        ),
    }),
  );
  console.log(
    "No editor data to parse",
    editorData,
    editorData === null ||
      editorData === undefined ||
      editorData === [] ||
      editorData.length === 0,
  );

  if (
    editorData === null ||
    editorData === undefined ||
    editorData === [] ||
    editorData.length === 0
  ) {
    return null;
  } else {
    return (
      <div
        id="post-body-parser-holder"
        className="post-body-parser"
        dangerouslySetInnerHTML={{
          __html: editorParser.parse(editorData).join(""),
        }}
      ></div>
    );
  }
}
